// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2y1DI","col":"CardReaderDesc_col__1---C","label":"CardReaderDesc_label__2ufWO"};